export const questions = [
  {
    name: '34000125-bd4e-4179-b141-cbaf45642f79',
    text: 'I have been able to laugh and see the funny side of things',
    options: [
      {
        name: '9e00e181-5580-45e7-996f-ed2b16323ccb',
        text: 'As much as I always could',
      },
      {
        name: '1649ba14-8fc6-499c-905e-018d4d471f73',
        text: 'Not quite so much now',
      },
      {
        name: 'b8cbf2a9-0686-4708-b278-21594acf7304',
        text: 'Definitely not so much now',
      },
      {
        name: 'dc7bb38a-ac1d-4a20-aa80-969e9ab0608c',
        text: 'Not at all',
      },
    ],
  },
  {
    name: '11180dfd-19c0-4436-8d3b-2e977d613eb0',
    text: 'I have looked forward with enjoyment to things:',
    options: [
      {
        name: '982640cc-d0d6-46a0-8498-790fe918240f',
        text: 'As much as I ever did',
      },
      {
        name: '643d8b7c-4491-4ab2-9b81-bc3beb56e74e',
        text: 'Rather less than I used to',
      },
      {
        name: '2d9d01c4-893f-47c2-b47d-d124a04cf413',
        text: 'Definitely less than I used to',
      },
      {
        name: '127bc04b-fe1f-4dd8-b249-261cf3430e7b',
        text: 'Hardly at all',
      },
    ],
  },
  {
    name: 'c31109b1-90fd-4b8b-8bd5-2a399b3821e8',
    text: 'I have blamed myself unnecessarily when things went wrong:',
    options: [
      {
        name: '03f1355e-9c29-4b1c-87d9-3d0074228a22',
        text: 'Yes, most of the time',
      },
      {
        name: '7618ad55-3d61-47e5-bebf-32d9aa5c114c',
        text: 'Yes, some of the time',
      },
      {
        name: '1409c2f6-6c52-46c9-9330-950c2357af7a',
        text: 'Not very often',
      },
      {
        name: '388e3649-4731-4778-8b03-5f0d0001b22f',
        text: 'No, never',
      },
    ],
  },
  {
    name: 'b8c16dbd-c879-470a-ae99-8c2a90d9c46c',
    text: 'I have been anxious or worried for no good reason:',
    options: [
      {
        name: 'fbf724bf-5b92-48ac-a9b8-b5e95108b965',
        text: 'No, not at all',
      },
      {
        name: 'fa2eff70-dc62-4dee-85e6-ab32181a3c5a',
        text: 'Hardly ever',
      },
      {
        name: '789fcfcc-de98-414f-a522-8c5518718e89',
        text: 'Yes, sometimes',
      },
      {
        name: 'e6c61b1a-b348-4049-b004-fcf42e7db271',
        text: 'Yes, very often',
      },
    ],
  },
  {
    name: 'fe492781-d23e-47e6-8ca8-55fef29f265d',
    text: 'I have felt scared or panicky for no good reason:',
    options: [
      {
        name: 'f657051b-d1e9-4a43-a6b8-ec91f10126a8',
        text: 'Yes, quite a lot',
      },
      {
        name: '975131b8-c3a3-4c65-8071-8f3b077e55b5',
        text: 'Yes, sometimes',
      },
      {
        name: 'a03d507d-33bc-4b22-995b-e6b3c0b60775',
        text: 'No, not much',
      },
      {
        name: '6ad648d1-ea0a-4990-ac67-0d41f607e222',
        text: 'No, not at all',
      },
    ],
  },
  {
    name: 'ecdb2b77-f8ff-4c99-a918-36a31aba779a',
    text: 'Things have been getting to me:',
    options: [
      {
        name: '1e0ef4ea-a45d-48dc-acfa-82e991d90c7b',
        text: "Yes, most of the time I haven't been able to cope at all",
      },
      {
        name: '390a0e35-556d-44b1-8891-3bc996903b75',
        text: "Yes, sometimes I haven't been coping as well as usual",
      },
      {
        name: '69cee943-c0e5-48e5-8dec-f4706a215e33',
        text: 'No, most of the time I have coped quite well',
      },
      {
        name: '46aae7fb-9451-4d36-b201-2513375085af',
        text: 'No, I have been coping as well as ever',
      },
    ],
  },
  {
    name: '0dbaf1a6-c4f6-433b-8cc5-acb60fe4bf1e',
    text: 'I have been so unhappy that I have found difficulty sleeping:',
    options: [
      {
        name: '44d1c082-1fd8-4e8d-855d-85b1c8f68911',
        text: 'Yes, most of the time',
      },
      {
        name: 'd9858020-b1df-4eca-abac-23fa84c5f3e3',
        text: 'Yes, sometimes',
      },
      {
        name: 'a463a95d-92b0-4dd3-ba8b-26eeb86ee936',
        text: 'No, not very often',
      },
      {
        name: 'e8883628-c228-420d-b4c3-1b8d375227b1',
        text: 'No, not at all',
      },
    ],
  },
  {
    name: 'a9792383-a743-4047-9c83-f4c7857b6de2',
    text: 'I have felt sad or miserable:',
    options: [
      {
        name: '51fab100-b1a6-43dc-ba3e-7a1d1273f4a4',
        text: 'Yes, most of the time',
      },
      {
        name: '69a98106-eaee-4b0f-8026-fa468251ef56',
        text: 'Yes, quite often',
      },
      {
        name: 'bdc3e846-d070-477a-8468-06e67e523dd1',
        text: 'Not very often',
      },
      {
        name: 'c9654cf2-3465-4083-b336-56f304823096',
        text: 'No, not at all',
      },
    ],
  },
  {
    name: '5365519a-7b3e-4399-8823-a1cac9524f6b',
    text: 'I have been so unhappy that I have been crying:',
    options: [
      {
        name: 'd018ed31-621a-48bf-a61c-10396ee0b9d5',
        text: 'Yes, most of the time',
      },
      {
        name: '9fabeadd-faed-49c6-8065-07daac57c968',
        text: 'Yes, quite often',
      },
      {
        name: 'f64c255d-3345-44b7-81b9-9af8ad1681cb',
        text: 'Only occasionally',
      },
      {
        name: 'bfef2b49-9d4d-46e1-884d-fb18a79684ea',
        text: 'No, never',
      },
    ],
  },
  {
    name: '369d81ce-e07e-46b5-b9f2-2fa834371a70',
    text: 'The thought of harming myself has occurred to me:',
    options: [
      {
        name: '3c3a60e0-1860-4f1b-aac5-e18e007ad5c6',
        text: 'Yes, quite often',
      },
      {
        name: '90e2b896-07fe-4987-a171-65577d2556cc',
        text: 'Sometimes',
      },
      {
        name: '8d26720d-e112-41a2-8357-ecbfb5353375',
        text: 'Hardly ever',
      },
      {
        name: '89ccba8e-6700-470c-a87c-fd68e3b4c090',
        text: 'Never',
      },
    ],
  },
];
